/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// HomeFr.js
import React from 'react';
import IntroBlock from './components/IntroBlock';
import NavButton from './components/NavButton';
import LanguageSwitcher from './components/LanguageSwitcher';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';

import BackgroundImage from './components/BackgroundImage';

import ModalEN from './components/ModalEN';

import './App.css';

export default function HomeFr( { onSwitchLanguage }) {

    const [showModal, setShowModal] = React.useState({invest: false, atouts: false, vivre: false, loisirs: false, initiative: false});

    const closeModal = () => {
        setShowModal({invest: false, atouts: false, vivre: false, loisirs: false, initiative: false});
    }

    const openModal = (id) => {
        setShowModal(prev => ({ ...prev, [id]: true }));
    }
    

    return (
            <div className="homepage">
            
                <div className="top-bar">
                    <LanguageSwitcher currentLang="en" onSwitch={onSwitchLanguage} />
                </div>
            
                <BackgroundImage/>
            
                <IntroBlock lang="en" onOpenModal={() => openModal('initiative')} />
            
            
                <div className="fixed-bottom-footer">
                    <Container fluid="xs">
                        <div className="footer-content">
                            <p>&copy; {new Date().getFullYear()} The Land Of Innovation</p>
                            <p className="credits">Photo credits: Pixabay and under licensing.</p>
                        </div>
                    </Container>
                </div>
            
            
                <NavButton label="Living" position="top-left" onClick={() => openModal('vivre')} />
                <NavButton label="Leisure" position="top-right" onClick={() => openModal('loisirs')} />
                <NavButton label="Assets" position="bottom-left" onClick={() => openModal('atouts')}/>
                <NavButton label="Investor Space" position="bottom-right" onClick={() => openModal('invest')}/>
            
            <ModalEN showModal={showModal} handleClose={closeModal} />
            
            </div>
            );
}
